/**
 * Single source of truth: exactly the 14 sidebar menu items, in sidebar order.
 * Each item's subtabs match the tabs on its page. No extra items.
 */
export const SIDEBAR_PERMISSION_STRUCTURE = [
  // 1. Dashboard
  { label: "Dashboard", key: "dashboard" },

  // 2. Metal Management
  {
    label: "Metal Management",
    key: "metaldetails",
    children: [
      { label: "Metals", key: "editMetal" },
      { label: "Rates", key: "metalPriceHistory" },
    ],
  },

  // 3. Transactions
  {
    label: "Transactions",
    key: "transaction",
    children: [
      { label: "Transactions", key: "transactionHistory" },
      { label: "Sell Orders", key: "sell" },
      { label: "Redeem Orders", key: "redeem" },
      { label: "Offline Orders", key: "offlineTransaction" },
      { label: "Diamond Points", key: "diamondPointsOrder" },
      { label: "Referral Points", key: "userPointsOrder" },
      { label: "Product Orders", key: "ProductOrder" },
      { label: "Gifts Transactions", key: "newGifts" },
      { label: "Auto Debit Subscriptions", key: "allSubscriptionList" },
    ],
  },

  // 4. App Management
  {
    label: "App Management",
    key: "appManagement",
    children: [
      { label: "Notifications", key: "customNotification" },
      { label: "Contents", key: "content" },
      { label: "Carousals", key: "carouselsettings" },
      { label: "App Theme", key: "appThemeSelector" },
      { label: "Customer Interaction", key: "customerInteraction" },
      { label: "Intro Screens", key: "introScreen" },
      { label: "Muhurat", key: "muhurt" },
      { label: "Interesting Facts", key: "interestingFacts" },
      { label: "Reports", key: "reports" },
      { label: "UI Arrangement", key: "uiArrangement" },
      { label: "Advertisement", key: "advertisement" },
    ],
  },

  // 5. Products Management
  {
    label: "Products Management",
    key: "productmanagement",
    children: [
      { label: "Products", key: "products" },
      { label: "Category", key: "productCategory" },
    ],
  },

  // 6. Plan Management
  {
    label: "Plan Management",
    key: "planManagement",
    children: [
      { label: "Create Sip", key: "createSipPlan" },
      { label: "Sip Subscribers", key: "allSipSubscribers" },
      { label: "Create Deposit Plan", key: "createDepositPlan" },
      { label: "Deposit Plan Subscriber", key: "allSubscribers" },
    ],
  },

  // 7. Gifts
  {
    label: "Gifts",
    key: "gifts",
    children: [
      { label: "Bulk Gifts", key: "bulkGifts" },
      { label: "Bulk Diamond Points", key: "bulkDiamondPoints" },
      { label: "Birthday Gift", key: "birthdayGift" },
      { label: "Registration Gift", key: "registrationGift" },
    ],
  },

  // 8. Customers
  {
    label: "Customers",
    key: "Customer",
    children: [
      { label: "All Customers", key: "allCustomers" },
      { label: "KYC Customers", key: "kycVerification" },
      { label: "Inactive Customers", key: "inactiveCustomer" },
      { label: "Block Customers", key: "blockCustomer" },
    ],
  },

  // 9. Admin
  {
    label: "Admin",
    key: "userManagement",
    children: [
      { label: "Create Admin", key: "admins" },
      { label: "Manage Role", key: "Permissions" },
    ],
  },

  // 10. Store
  { label: "Store", key: "storemanagement" },

  // 11. Offers
  {
    label: "Offers",
    key: "offers",
    children: [
      { label: "Diamond Points", key: "diamondPoints" },
      { label: "VIP Customers", key: "vipConfig" },
      { label: "Flash Offers", key: "flashoffers" },
      { label: "Metal Rewards", key: "metalRewards" },
      { label: "Referral", key: "referralBenefits" },
    ],
  },

  // 12. Jeweller
  { label: "Jeweller", key: "jeweller" },

  // 13. Subscriptions
  {
    label: "Subscriptions",
    key: "subscription",
    children: [
      { label: "Subscription Plans", key: "subscriptionMain" },
      { label: "Subscriptions", key: "subscriptionList" },
      { label: "Coupons", key: "couponlist" },
      { label: "Jeweller Subscriptions", key: "jewellerSubscriptionList" },
    ],
  },

  // 14. Settings
  {
    label: "Settings",
    key: "settings",
    children: [
      { label: "Jeweller Configurations", key: "configuration" },
      { label: "App Configurations", key: "appConfig" },
      { label: "Settings", key: "settingsMain" },
    ],
  },
  {label: "Ticket Management", key: "ticket" },

  // Special (not in sidebar; used for Instalaxmi section visibility and toggles)
  { label: "instalaxmiPermission", key: "instalaxmiPermission" },
  { label: "jewellerPermission", key: "jewellerPermission" },
  { label: "Dashboard Info", key: "dashboardInfo" },

   {
    label: "Booking Bullion",
    key: "bookingBullionPage",
    children: [
      { label: "Booking Transaction", key: "bookingTransaction" },
      { label: "Booking Request", key: "bookingBullion" },
      { label: "Booking Report", key: "bookingReport" },
    ],
  },
  { label: "Training", key: "training" },
  { label: "Leads", key: "leads" },

];

/**
 * Returns all leaf permission keys (for API / permission checks).
 */
export function getLeafKeysFromStructure(structure = SIDEBAR_PERMISSION_STRUCTURE) {
  const keys = [];
  for (const item of structure) {
    if (!item.children || item.children.length === 0) {
      keys.push(item.key);
    } else {
      for (const child of item.children) {
        keys.push(child.key);
      }
    }
  }
  return keys;
}
